/*
These functions make sure WordPress
and Foundation play nice together.
*/

var $win = jQuery(window),
  $body = jQuery("body");
  $ = jQuery;

// jQuery(".nav-subscribe").on("click", function () {
//   jQuery("#ae-cform-modal-display-cta-2").trigger("click");
// });

jQuery('#umg-live-gigs-table tr').each(function(event){
	// jQuery(this).children().slice(0, 3).wrapAll('<div class="umg-locations"/>')
	jQuery(this).children().slice(3).wrapAll('<div class="umg-tickets"/>')
})	

// Remove empty P tags created by WP inside of Accordion and Orbit
jQuery(".accordion p:empty, .orbit p:empty").remove();

// Adds Flex Video to YouTube and Vimeo Embeds
jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(
  function () {
    if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
      jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      jQuery(this).wrap("<div class='responsive-embed'/>");
    }
  }
);
jQuery(window).on("load", function () {
  jQuery("#ae-cform-input-reg-email-1").attr("placeholder", "Email");

  jQuery(".top-bar .menu-bars").on("click", function () {
    jQuery(this).find(".fas").toggleClass("fa-times");
  });
  jQuery(".js-off-canvas-overlay").on("click", function () {
    jQuery(".top-bar .menu-bars .fas").removeClass("fa-times");
  });

  jQuery(".js-subscribe a").on("click", function (e) {
    e.preventDefault();

    var $target = jQuery(this).attr("href");

    jQuery("html, body").animate(
      {
        scrollTop: jQuery($target).offset().top,
      },
      800
    );

    if (jQuery(this).parents(".off-canvas")) {
      jQuery(".js-off-canvas-overlay").trigger("click");
    }
  });



  if ($body.hasClass("home")) {
    var $banner = jQuery(".js-banner"),
      $videos = jQuery(".js-video-list"),
      $releases = jQuery(".js-release-list"),
      $film = jQuery("#film .js-list"),
			$merch = jQuery(".merch-list"),
      $menu = jQuery("#main-nav li a");

    setTimeout(function () {
      jQuery("#ae-cform-modal-display-cta-2").trigger("click");
    }, 15000);

    var navBar = $('#home-bar-menu');
    var shouldStickPosition = navBar.offset().top;

    function toggleStickyNav() {
      if (window.pageYOffset >= shouldStickPosition) {
        navBar.addClass('sticky')
      } else {
        navBar.removeClass('sticky')
      }
    }

    window.addEventListener("scroll", function(){
      toggleStickyNav();
    })

    $(window).on("resize", function() {
      var shouldStickPosition = navBar.offset().top;
    })

    

    $banner.slick({
      dots: false,
      fade: true,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: 815,
          settings: {
            arrows: true,
          },
        },
      ],
    });

    //jQuery( "<div class='triangle'><div></div></div>" ).appendTo( ".slick-arrow" );

    jQuery(".section-banner").addClass("init");

    $banner.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        $banner.addClass("is-sliding");
      }
    );

    $banner.on("afterChange", function (event, slick, currentSlide) {
      $banner.removeClass("is-sliding");
    });

    $releases.slick({
      slidesToScroll: 1,
      slidesToShow: 3,
      speed: 500,
      cssEase: "ease-in-out",
      useTransform: true,
      dots: false,
      fade: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });


    $videos.slick({
      dots: false,
      fade: true,
      cssEase: "linear",
    });



    $merch.slick({
      mobileFirst: true,
      fade: false,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick",
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
          },
        },
      ],
    });

    
    $(window).on("resize", function () {
       $film = jQuery("#film .js-list"),
			$merch = jQuery(".merch-list"),

      $film.slick("resize");
      $merch.slick("resize");
    });

    function scrollDownNav(target) {
      event.preventDefault();
      $('.js-off-canvas-overlay').trigger('click')
      
      if(screen.width >= 1024) {
        $('html,body').animate({scrollTop: $(target).offset().top - 50},'slow');
      } else {
        $('html,body').animate({scrollTop: $(target).offset().top},'slow');
      }
    }
    $('.custom-logo-link').on('click', function(event){
      scrollDownNav('.section-banner')
    });
    $('.nav-music').on('click', function(event){
      scrollDownNav('#music')
    });
    $('.nav-videos').on('click', function(event){
      scrollDownNav('#videos')
    });
    $('.nav-film').on('click', function(event){
      scrollDownNav('#film')
    });
    $('.nav-tour').on('click', function(event){
      scrollDownNav('#tour')
    });
    $('.nav-about').on('click', function(event){
      scrollDownNav('#about')
    });
    $('.nav-store, .nav-merch').on('click', function(event){
      scrollDownNav('#merch')
    })

    if($('.umg-live-no-gigs').length > 0) {
      $('#tour .section-footer').hide();
    }

    const SVG_PATHS = [
      {value: 'M161.23691003228475,-142.91547838970675C181.22293223201214,-103.52046591026897,150.56953271518822,-38.07519551682116,132.17827658263366,25.22354638199265C113.78702045007908,88.52228828080645,107.65790770179386,149.67450168498627,78.41569906755855,164.33349172080008C49.17349043332327,178.9924817566139,-3.181814086862076,147.15824842406178,-56.01312467781069,120.21665030992501C-108.8444352687593,93.27505219578826,-162.15175193047116,71.2260893000669,-187.94767695994662,24.05229400148208C-213.74360198942205,-23.12150129710275,-212.02813538666103,-95.42012899855102,-176.1182906212972,-138.44965006594194C-140.20844585593338,-181.47917113333287,-70.10422292796669,-195.23958556666642,0.2606104941560024,-195.44741550061937C70.62544391627868,-195.65524543457227,141.25088783255737,-182.3104908691445,161.23691003228475,-142.91547838970675Z'},
      {value: 'M170.78591811428797,-133.0305582253273C215.9575780453791,-79.55375495201808,243.49376881596302,-8.846467656081344,223.1542396176616,39.17174551675614C202.81471041936013,87.18995868959364,134.59946125217326,112.51909773933187,75.54352166932024,131.03996490556673C16.48758208646723,149.56083207180157,-33.40904791205195,161.27342735453303,-79.08302414200442,146.1982143784705C-124.7570003719569,131.123001402408,-166.20832283334266,89.25998016755149,-178.1244821030258,39.85381293333588C-190.04064137270893,-9.552354300879733,-172.42163745068942,-66.50166753445447,-137.81169656823468,-117.56782735657032C-103.20175568577996,-168.63398717868614,-51.60087784288998,-213.81699358934307,5.6031256243542105,-218.28533716933066C62.8071290915984,-222.75368074931828,125.6142581831968,-186.50736149863656,170.78591811428797,-133.0305582253273Z'},
      {value: 'M154.9381779423472,-120.05907383094858C193.12285450280197,-75.6770039176596,211.11545693276526,-11.692292218962868,194.79896584777973,38.31340346486829C178.48247476279414,88.31909914869944,127.85689016285976,124.34577881766502,78.96974803750525,137.8542743126357C30.082605912150722,151.36276980760638,-17.06609373862393,142.3530811285822,-68.12265455956624,124.33974129409943C-119.17921538050855,106.32640145961666,-174.14363737161855,79.3094104696753,-189.6325264693978,36.198603365814726C-205.12141556717702,-6.912203738045851,-181.13477177162554,-66.11682695582563,-142.95009521117078,-110.49889686911462C-104.76541865071601,-154.8809667824036,-52.38270932535801,-184.4404833912018,2.9970206827941106,-186.8305276316603C58.37675069094623,-189.22057187211877,116.75350138189246,-164.44114374423756,154.9381779423472,-120.05907383094858Z'},
      {value: 'M117.72894557886714,-73.05236786699797C158.83840587586738,-42.33606848517338,202.74758382893438,6.980863902887076,196.4645967689552,48.985107129531144C190.18160970897603,90.98935035617522,133.70645763595073,125.6809044214029,72.42140346998403,158.19299073037413C11.136349304017353,190.70507703934538,-54.95860695489066,221.03769559206015,-110.07736740992392,203.95152631572867C-165.19612786495716,186.8653570393972,-209.33869251611566,122.3603999340195,-224.99704159360058,51.88873165803174C-240.65539067108548,-18.582936617956026,-227.82952417489687,-95.02131606455384,-185.5826479803512,-125.9972232026608C-143.3357717858055,-156.97313034076777,-71.66788589290275,-142.4865651703839,-16.679071625984644,-129.1854493973976C38.30974264093346,-115.88433362441128,76.61948528186691,-103.76866724882257,117.72894557886714,-73.05236786699797Z'},
      {value: 'M193.2321776439259,-155.76418621349498C237.91637361892617,-98.06531007383057,253.0107747344638,-18.436026617922067,232.5059893167388,45.71687890662718C212.0012038990138,109.86978443117641,155.89723194802608,158.54631202436642,95.01470971263701,181.98360695305897C34.13218747724793,205.42090188175155,-31.52888504254253,203.61896414594673,-90.7329472073219,178.79857165911304C-149.93700937210124,153.9781791722794,-202.6840611818695,106.13933193441692,-217.75899422020188,47.56356879171059C-232.83392725853423,-11.012194350995722,-210.23674152543072,-80.32487339854588,-167.66488936015773,-137.5416208479716C-125.09303719488479,-194.75836829739737,-62.54651859744239,-239.87918414869867,5.863736118510218,-244.55535766263915C74.27399083446282,-249.2315311765797,148.54798166892564,-213.46306235315942,193.2321776439259,-155.76418621349498Z'}
    ];
    
    const MORPH_SVG = anime({
      targets: '#morph',
      d: [
        SVG_PATHS[1],
        SVG_PATHS[2],
        SVG_PATHS[3],
        SVG_PATHS[4],
        SVG_PATHS[0]
      ],
      easing: 'linear',
      duration: 20000,
      loop: true
    });


    jQuery(".article-video .play-button").on("click", function (e) {
      e.preventDefault();

      var youtubeID = jQuery(this).data("id"),
        embedCode =
          "<div class='media-youtube-video'><iframe src='https://www.youtube.com/embed/" +
          youtubeID +
          "?showinfo=0&autohide=1&rel=0&autoplay=1&wmode=transparent' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div>",
        $parent = jQuery(this).parents(".type-video");

      if (!document.querySelector(".media-youtube-video")) {
        $parent.addClass("playing");
        $parent.append(embedCode);
        jQuery(".js-video-list").addClass("has-embed");
      } else {
        $parent.removeClass("playing");
        jQuery(".media-youtube-video").remove();
        jQuery(".js-video-list").removeClass("has-embed");
      }
    });
    jQuery(".js-video-list > button").on("click", function () {
      if (jQuery(".article-video").hasClass("playing")) {
        jQuery(".media-youtube-video").remove();
        jQuery(".article-video").removeClass("playing");
        jQuery(".js-video-list").removeClass("has-embed");
      }
    });

    jQuery(".js-intro-arrow").on("click", function (e) {
      e.preventDefault();
  
      jQuery("html, body").animate(
        {
          scrollTop: jQuery(".section-music").offset().top - 64,
        },
        500
      );
    });

    jQuery('.anchor-down').on('click', function(e){
      e.preventDefault();
      var nextSection = jQuery(this).closest('.section').next();

      if(screen.width > 900) {
        var paddingTop = 150;
      } else {
        paddingTop = 0;
      }


      jQuery("html, body").animate(
        {
          scrollTop: jQuery(nextSection).offset().top - paddingTop,
        },
        500
      );

    })

    jQuery(".main-home .section").each(function () {
      var self = jQuery(this);

      jQuery(this).waypoint({
        handler: function (direction) {
          // if(direction == 'down') {
          // }

          // jQuery('.main-home .section').removeClass('show');
          self.addClass("show");
        },
        offset: "50%",
      });
    });

    if ($win.width() < 480) {
      var waypoints = jQuery(".section-about").waypoint({
        handler: function (direction) {
          if (direction == "up") {
            jQuery("#top-bar-menu .logo").removeClass("show");
          } else {
            jQuery("#top-bar-menu .logo").addClass("show");
          }
        },
        offset: "0",
      });
    }
  }
});
